import React, {Component} from "react";
import {Route, Switch, withRouter} from "react-router-dom";
import {Routes} from "./utils/Routes";
import HomeView from "./home/HomeView";
import ScanInductLocationView from "./inductLocation/ScanInductLocationView";
import ScanPackageView from "./receivePackage/ScanPackageView";
import ScanPrinterView from "./scanPrinter/ScanPrinterView";
import SALPrinterContextProvider from "./scanPrinter/context/SALPrinterContext";
import InductLocationContextProvider from "./inductLocation/context/InductLocationContext";
import ReceivePackageContextProvider from "./receivePackage/context/ReceivePackageContext";
import AppNavigationContextProvider from "./appNavigation/context/AppNavigationContext";
import AppNavigation from "./appNavigation/AppNavigation";
import "dolphin-meridian-react-components/dist/index.css";
import Column from "@meridian/components/column";
import {publishCountToDolphinCSM} from "./helper/PUMAMetricHelper";
import {StringConstant} from "./utils/StringConstant";

function publishRoutePath(location) {
    const metricName = location.pathname;
    publishCountToDolphinCSM(metricName);
}
class App extends Component {

    componentWillMount() {
        const lastSavedUrl = localStorage.getItem(StringConstant.LOCAL_STORAGE_URL_KEY);
        if (this.props.location.pathname.endsWith(Routes.NEW_SESSION)) {
            localStorage.removeItem(StringConstant.LOCAL_STORAGE_URL_KEY);
            this.props.history.replace(`${Routes.HOME}${this.props.location.search}`);
        } else if (lastSavedUrl) {
            this.props.history.replace(`${lastSavedUrl}${this.props.location.search}`);
        }
        publishRoutePath(this.props.location);
        this.onRouteSwitch = this.props.history.listen(() => {
            publishRoutePath(this.props.location);
        });
    }

    componentWillUnmount() {
        this.onRouteSwitch();
    }

    componentDidUpdate(prevProps) {
        if(this.props.location.pathname !== prevProps.location.pathname ||
            this.props.location.search !== prevProps.location.search) {
            localStorage.setItem(StringConstant.LOCAL_STORAGE_URL_KEY, this.props.location.pathname);
        }
    }

    render() {
        return (
            <Switch>
                <AppNavigationContextProvider>
                    <Column height="100%" spacing="none">
                        <AppNavigation/>
                        <div className="content">
                            <SALPrinterContextProvider>
                                <Route exact path={Routes.HOME} component={HomeView}/>
                                <InductLocationContextProvider>
                                    <Route exact path={Routes.INDUCT_LOCATION_WITH_PROPS} component={ScanInductLocationView} />
                                </InductLocationContextProvider>
                                <ReceivePackageContextProvider>
                                    <Route exact path={Routes.RECEIVE_PACKAGE_WITH_PROPS} component={ScanPackageView} />
                                    <Route exact path={Routes.SCAN_PRINTER_WITH_PROPS} component={ScanPrinterView} />
                                </ReceivePackageContextProvider>
                            </SALPrinterContextProvider>
                        </div>
                    </Column>
                </AppNavigationContextProvider>
            </Switch>
        );
    }
}

export default withRouter(App);


// WEBPACK FOOTER //
// ./src/components/App.js